'use client'
import React, { useEffect, useState } from 'react';
import Typography from '@/components/atoms/typography';
import Link from '@/components/atoms/link';
import Image from '@/components/atoms/Image';
import Markdown from '@/components/atoms/markdown';
import { useLocale } from 'next-intl';


const WarrantyPage = ({ WarrantyPageData }: any) => {
    const sectionData = WarrantyPageData?.sections?.[0]?.info_section_with_image;
    const description = sectionData?.description ?? '';
    const title = sectionData?.title ?? '';
    const cardsData = sectionData?.content_with_icon ?? [];
    const [pageLoaded, setPageLoaded] = useState(false);
    const locale=useLocale();

    useEffect(() => {
        const handleLoad = () => {
            setPageLoaded(true);
        };

        if (document.readyState === 'complete') {
            // Page already loaded (e.g., fast navigation)
            setPageLoaded(true);
        } else {
            // Wait for full load
            window.addEventListener('load', handleLoad);
        }

        return () => {
            window.removeEventListener('load', handleLoad);
        };
    }, []);
console.log('locale',locale)
    return (
        <div className={`flex justify-center flex-col  px-[24px] lg:px-10   py-5 pt-[0.625rem] ${!pageLoaded && "mt-[181px]"}`}>
            <div className="flex flex-col items-center">
                <Typography
                    className="pb-3 text-[24px] lg:text-[48px] !font-medium  leading-10 text-gray-700 text-center"
                >
                    {title}
                </Typography>
            </div>
            <Markdown className='text-[16px] md:text-[20px] lg:text-[24px] warranty-description '>{description}</Markdown>
            <div className='flex w-full justify-center flex-wrap gap-[27px] md:gap-[65px]  mb-[100px] mt-[48px]' >
                {
                    cardsData?.map((card: any, index: number) => {
                        return (
                            <Link key={index} link={card?.link} target='_blank' className='w-[170px] md:w-[250px] flex justify-center items-center h-[138px] md:h-[200px] border-[1px] border-[#828282] rounded-[5px] shadow-md shadow-[#828282]' >
                                <div className='' >
                                    <Image src={card?.icon?.url} width={
                                        locale === "au"
                                            ? index === cardsData.length - 1
                                                ? 160
                                                : index === cardsData.length - 2
                                                    ? 100
                                                    : 200
                                            : index === cardsData.length -1
                                                ? 100
                                                : 200 
                                    } height={50} alt={card?.icon?.alt} />
                                </div>
                            </Link>
                        )
                    })
                }
            </div>
        </div>
    );
};

export default WarrantyPage;